<div class="manage-relative-modal">

  <div class="container-close-button" (click)="onClose()">
    <img ngSrc="/assets/images/icons/cross.svg" alt="Icon cross" height="24" width="24">
  </div>

  <app-shared-modal-header
    title='Modifier le profil du proche'
    subtitle="Veuillez remplir le formulaire ci-dessous pour modifier le profil du proche"
    iconName="edit"
    [isDeleteModal]="false">
  </app-shared-modal-header>

  <div class="container-modal-form">
    <div class="container-error-block" *ngIf="error">
      {{ error.code | translate }}
    </div>
    <div class="container-form-with-upload">
      <shared-manage-picture [pictureUrl]="pictureUrl" (fileSelected)="getFileSelected($event)"></shared-manage-picture>
      <form *ngIf="profileForm" [formGroup]="profileForm">
        <div class="container-input-inline">
          <mat-form-field>
            <mat-label>Prénom</mat-label>
            <input matInput placeholder="Saisissez un prénom" type="text" formControlName="firstName" required>
            <mat-error *ngIf="profileForm.controls['firstName'].hasError('required')">Veuillez saisir un prénom valide.
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Nom</mat-label>
            <input matInput type="text" placeholder="Saisissez un nom" formControlName="lastName" required>
            <mat-error *ngIf="profileForm.controls['lastName'].hasError('required')">Veuillez saisir un nom valide.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="container-input-inline">
          <mat-form-field>
            <mat-label>Surnom</mat-label>
            <input matInput type="text" placeholder="Saisissez un surnom" formControlName="nickName">
          </mat-form-field>
<!--          <mat-form-field-->
<!--            matTooltip="Chez CoucouVisio, nous utilisons la date de naissance pour envoyer une carte d'anniversaire personnalisée à votre proche le jour de son anniversaire.">-->
<!--            <mat-label>Date de naissance</mat-label>-->
<!--            <input matInput type="date" formControlName="birthDate">-->
<!--          </mat-form-field>-->
        </div>
        <mat-form-field>
          <mat-label>Numéro de téléphone du proche</mat-label>
          <input matInput placeholder="Saisissez un numéro de téléphone" type="text" formControlName="phone" required>
          <mat-error *ngIf="profileForm.controls['phone'].hasError('required')">Veuillez saisir un numéro de téléphone
            valide.
          </mat-error>
          <mat-error *ngIf="profileForm.controls['phone'].hasError('pattern')">Le format du numéro n'est pas bon. (ex:
            06xxxxxx21)
          </mat-error>
        </mat-form-field>
      </form>
    </div>
  </div>

  <div class="container-modal-actions">
    <button mat-stroked-button (click)="onClose()"
            class="full-width base"
            type="button">
      <div class="icon">
        Annuler
      </div>
    </button>
    <button mat-flat-button (click)="submit()"
            class="full-width"
            color="accent"
            type="button"
            [disabled]="!profileForm.valid || isLoading">
      <div *ngIf="!isLoading">Valider</div>
      <div *ngIf="isLoading">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </button>
  </div>

</div>
